import React, { Fragment } from 'react';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';

import { getContactsConditions } from '../utils/getContactConditions';
import ContactInfoSection from '../ContactInfoSection';
import { HomeAddress } from '../HomeAddress';
import { enhance } from './enhance';
import { getPhoneWithoutUSCode } from '../../../utils/getPhone';
import EmergencyContact from '../EmergencyContact';
import { PROFILE_SECTIONS } from '../../../constants';
import FieldsetList from '../FieldSetList';
import deepTrim from '../../../utils/converters/deepTrim';
import { getPatientFieldsetList } from '../utils/getFieldset';

const PatientProfile = props => {
  const {
    profile,
    canEdit,
    saveUser,
    savePatient,
    canEditPatient,
    intl: { formatMessage },
    countryList,
    isSucceedUpdate,
    relationList,
    profileEditable,
    isSucceedPatientUpdate,
  } = props;
  const { id, email, phoneNumber, primaryContactsEnabled } = profile;
  const { showEmail, showPhoneNumber } = getContactsConditions(
    profile,
    canEditPatient,
  );

  const handleSave = (data, type) => {
    if (type === PROFILE_SECTIONS.EMERGENCY_CONTACT) {
      return;
    }
    // exclude ssn, because it's with *
    const checkedData = deepTrim(profileEditable ? data : omit(data, ['ssn']));

    saveUser({ ...checkedData, id });
  };

  const isEditable = canEdit || canEditPatient;

  return (
    <Fragment>
      <ContactInfoSection
        canEdit={canEdit || primaryContactsEnabled}
        email={showEmail ? email : null}
        phoneNumber={
          showPhoneNumber ? getPhoneWithoutUSCode(phoneNumber) : null
        }
      />
      <FieldsetList
        fieldSetList={getPatientFieldsetList(props)}
        onSave={handleSave}
        disabled={!isEditable}
        canEdit={isEditable}
      />
      <EmergencyContact
        profile={profile}
        canEdit={canEdit}
        savePatient={savePatient}
        relationList={relationList}
        formatMessage={formatMessage}
        isSucceedUpdate={isSucceedPatientUpdate}
      />
      <HomeAddress
        formatMessage={formatMessage}
        profile={profile}
        canEdit={canEdit}
        countryList={countryList}
        saveUser={saveUser}
        isSucceedUpdate={isSucceedUpdate}
      />
    </Fragment>
  );
};

PatientProfile.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string,
    emailFake: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    phoneNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    weight: PropTypes.number,
    height: PropTypes.number,
  }),
  savePatient: PropTypes.func,
  saveUser: PropTypes.func,
  canEdit: PropTypes.bool,
  canEditPatient: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  countryList: PropTypes.array,
  profileEditable: PropTypes.bool,
  isSucceedUpdate: PropTypes.bool,
  relationList: PropTypes.array,
  isSucceedPatientUpdate: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  ssnHidingEnabled: PropTypes.bool,
};

export default enhance(PatientProfile);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/PatientProfile/index.jsx